export const exportHeaders = [
    { 
        label: "Shipto", 
        key: "customer_account_number" 
    },
    { 
        label: "First Name", 
        key: "first_name" 
    },
    { 
        label: "Last Name", 
        key: "last_name" 
    },
    { 
        label: "Email", 
        key: "email" 
    },
    { 
        label: "Super Admin", 
        key: "super_administrator" 
    },
    {
        label: "User Admin",
        key: "user_admin",
    },
    { 
        label: "Approver Flag", 
        key: "approver" 
    },
    { 
        label: "Budgeter Flag", 
        key: "budgeter" 
    },
    { 
        label: "Report Access Flag", 
        key: "report_access" 
    },
    { 
        label: "Online Payment Flag", 
        key: "online_payment" 
    },
    { 
        label: "Advanced Account Mngt Flag", 
        key: "advanced_account_management" 
    },
    { 
        label: "Master User Flag", 
        key: "master_user" 
    },
    { 
        label: "Loyalty Role", 
        key: "role_name" 
    },
]